import React from "react";

const ThemeAlternative = (props) => {
    return (
        <div className="bg-skin-primary-light py-8">
            <div className="max-w-5xl mx-auto">{props.children}</div>
        </div>
    );
};

const ThemeWrap = ({ theme, children }) => {
    theme = theme ? theme : "Default";
    if (theme === "MultiColumns") {
        return <div className="max-w-5xl mx-auto">{children}</div>;
    } else if (theme === "None" || theme === "Default") {
        return <>{children}</>;
    } else {
        return <ThemeAlternative>{children}</ThemeAlternative>;
    }
};

export default ThemeWrap;
